import storageFactory from './storage-factory';

const lStorage = storageFactory(() => localStorage);
const sStorage = storageFactory(() => sessionStorage);

export default lStorage.isSupported() ? lStorage : sStorage;

